/**
 * Creates a getHref function that conditionally rewrites module URLs
 * to use preview paths.
 *
 * @param configPreview - Whether the hub is globally in preview mode
 */
export function createGetHref(configPreview: boolean) {
  return function getHref(
    href?: string | null,
    preview = false,
  ): string | null {
    if (!href) return null;
    if (configPreview || preview) {
      if (href.indexOf('preview') < 0) {
        href = href.replace('/modules/', '/modules/preview/');
      }
    }
    return href;
  };
}
